module.exports = __webpack_public_path__ + "static/media/fireworks.bed02fbe.png";